<template>
    <div>

        <!-- API방식 선택 -->
        <div class="uk-flex uk-flex-center uk-flex-middle mb-2rem">
            <p-radio
                v-for="(opt, index) in apiVersionOptions"
                :key="index"
                class="p-icon p-curve font-size-1d125rem"
                color="primary"
                name="reason-type"
                :value="opt.name"
                :checked = "apiVersion === opt.name"
                v-model="apiVersion"
            >
                <i slot="extra" class="icon mdi mdi-check"></i>
                {{ opt.text }}
            </p-radio>
        </div>

        <div class="uk-flex uk-flex-center uk-flex-wrap">
            <!-- 이전방식 -->
            <old
                v-show="apiVersion === 'old'"

                class=""

                :csrf-token="csrfToken"
                :init-text="initApiVersion === 'old' ? initText : null"
                :init-check="initApiVersion === 'old' ? initCheck : null"
                :login-user-id="loginUserId"
                :loginUserNick="loginUserNick"

                ref="old"

            ></old>

            <!-- 새 방식 -->
            <ver2026
                v-show="apiVersion === 'ver2026'"

                :csrf-token="csrfToken"
                :init-text="initApiVersion === 'ver2026' ? initText : null"
                :init-check="initApiVersion === 'ver2026' ? initCheck : null"
                :login-user-id="loginUserId"
                :loginUserNick="loginUserNick"

                ref="ver2026"
            ></ver2026>
        </div>
    </div>

</template>

<script>
    import old from "./old.vue";
    import ver2026 from "./ver2026.vue";

    export default {
        components: {
            old,
            ver2026,
        },

        props: {
            // csrf-token
            csrfToken: String,

            // 초기입력 값
            initText: {
                type: String,
                default: null,
            },

            // 초기검색 실행여부
            initCheck: {
                type: Boolean,
                default: false,
            },

            // 초기검색 실행 api버전
            initApiVersion: {
                type: String,
                default: 'old',
            },

            // 로그인 ID
            loginUserId: {
                type: Number,
                default: null
            },

            // 로그인 닉네임
            loginUserNick: {
                type: String,
                default: null
            },
        },
        data: function () {
            return {
                apiVersionOptions: [
                    {name: 'old', text: "이전방식"},
                    {name: 'ver2026', text: "신규방식 (25년 11월 21일 이후 발급)"},
                ],
                apiVersion: this.initApiVersion,
            };
        },
        mounted: function () {

        },
        computed: {

        },
        methods: {



        },
    }
</script>

<style lang="scss" scoped>

</style>